import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";
import {trackPromise} from "react-promise-tracker";

export const requestJobsAsync = (pageUrl) => {
  const url = pageUrl ? pageUrl : getUrl("getJobs");
  return trackPromise(Call.get(url));
};

export const requestJobAsync = ({id}) => {
  const url = getUrl("getJob")(id);
  return Call.get(url);
};
